// A draft waiting for an App's own chat to open. "Fix in chat" opens that chat by navigation, and the
// navigation is what carries the draft: the open chat at the moment of the click is never written into,
// and nothing is sent. One slot, keyed by the chat it is for, so a draft never lands in another chat.
import { chatIdFromHash } from '@/lib/chat-links';

type Waiting = { threadId: string; text: string };

let waiting: Waiting | null = null;
const listeners = new Set<() => void>();

/** Leaving for any address that is not the waiting chat (another chat, the Apps page, Back) abandons the draft. The
 * draft's own navigation is written, and its hashchange dispatched, before the draft is queued. */
function abandonOnNavigation() {
  if (waiting && chatIdFromHash(location.hash) !== waiting.threadId) waiting = null;
  if (!waiting) window.removeEventListener('hashchange', abandonOnNavigation);
}

export function queueAppChatDraft(threadId: string, text: string) {
  waiting = { threadId, text };
  window.addEventListener('hashchange', abandonOnNavigation);
  for (const listen of [...listeners]) listen();
}

/** The draft for this chat if one is waiting; it is handed over once. */
export function takeAppChatDraft(threadId: string): string | null {
  if (!waiting || waiting.threadId !== threadId) return null;
  const { text } = waiting;
  waiting = null;
  window.removeEventListener('hashchange', abandonOnNavigation);
  return text;
}

/** The chat changed to one the draft is not for: the navigation it waited on never came, so it is dropped. */
export function dropAppChatDraftNotFor(threadId: string) {
  if (waiting && waiting.threadId !== threadId) waiting = null;
}

export function onAppChatDraftQueued(listen: () => void) {
  listeners.add(listen);
  return () => void listeners.delete(listen);
}
